__turbopack_context__.v({
  "drawerButton": "[id]-module__J-wK-q__drawerButton",
  "drawerHeader": "[id]-module__J-wK-q__drawerHeader",
  "legendsToggle": "[id]-module__J-wK-q__legendsToggle",
  "legendsToggleSm": "[id]-module__J-wK-q__legendsToggleSm",
  "navItem": "[id]-module__J-wK-q__navItem",
  "sidebar": "[id]-module__J-wK-q__sidebar",
  "slogan": "[id]-module__J-wK-q__slogan",
  "title": "[id]-module__J-wK-q__title",
  "top10": "[id]-module__J-wK-q__top10",
  "top100": "[id]-module__J-wK-q__top100",
  "userPosition": "[id]-module__J-wK-q__userPosition",
});
